<script lang="ts" setup>
import { ScanResult } from "@capacitor-community/bluetooth-le";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import PoolIcon from "@/features/pools/PoolIcon.vue";
import { useStoredBlePool } from "@/features/ble/utils/localStorage.ts";
import { useDevMode } from "@/shared/mixins/useDevMode.ts";
import BlePopoverWrapper from "@/features/ble/scan/BlePopoverWrapper.vue";
import BleSignalIcon from "@/features/ble/scan/BleSignalIcon.vue";

const props = defineProps<{
  result: ScanResult;
}>();

const isConnecting = ref(false);

const router = useRouter();
const connect = async () => {
  isConnecting.value = true;
  console.log("Connecting to", props.result.device.deviceId);
  isConnecting.value = false;
  router.push({
    path: `/pool/ble:${props.result.device.deviceId}`,
  });
};

const storedBlePool = useStoredBlePool(
  computed(() => props.result.device.deviceId)
);

const { enabled: devModeEnabled } = useDevMode();
</script>

<template>
  <BlePopoverWrapper :pool="storedBlePool">
    <div class="card p-4 cursor-pointer flex items-center" @click="connect">
      <div class="flex-grow-0 flex-shrink-0" style="width: 32px; height: 32px">
        <PoolIcon :is-ble="true" />
      </div>

      <div class="flex-shrink ml-3 flex-grow">
        <div class="text-md font-medium mb-0.5 flex">
          <div class="flex flex-col">
            {{ storedBlePool?.localNickname ?? result.localName }}

            <div v-if="devModeEnabled">
              {{ result.localName }} ({{ result.rssi }}dBm)
            </div>
          </div>
        </div>
      </div>

      <BleSignalIcon :rssi="result.rssi" :scale="1.2" />
    </div>
  </BlePopoverWrapper>
</template>
